import React, { Component } from 'react';
import { Icon } from '@trlogic/ui-pack';
import * as domain from 'domain';
import { WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import CustomLoading from '../../custom/CustomLoading';
import WatchlistDataNotFoundComponent from './WatchlistDataNotFoundComponent';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistCustomerDomainsComponent extends Component<Props, State> {
  public state: State = new State();

  render() {
    const { response, customerLoading } = this.props;
    return (
      <div className={'w-full flex flex-col h-auto bg-[#F9FAFB] rounded-md border-[1px] border-[#E0E4E8] rounded-xl'}>
        <div className={'border-b-[1px] border-[#E0E4E8] p-4'}>
          {LanguageUtil.get({ id: 'pages.alert.socialMedia.domainInformation', defaultMessage: 'Domain Information' })}
        </div>
        <div className={'grid grid-cols-1 gap-4 overflow-y-scroll overflow-x-hidden h-[400px] bg-white rounded-xl'}>
          {customerLoading ? (
            <CustomLoading />
          ) : response == undefined ? (
            <WatchlistDataNotFoundComponent />
          ) : (
            response?.domain && (
              <div className={'flex flex-col w-full'}>
                {Object.entries(this.getData()).map(([key, value], index) => (
                  <div key={index} className={'flex justify-between items-center border-b-[1px] border-[#E0E4E8] bg-white p-4'}>
                    <span className={'w-1/2'}>
                      {this.getIcon(key)} {key}
                    </span>
                    <span className={'w-1/2 text-[12px] text-f-black-2 rounded-xl px-2'}>{value != undefined && value.toString()}</span>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    );
  }

  private getData = () => {
    const { response } = this.props;
    return {
      Name: response!.domain.domainName || '-',
      Organization: response!.domain.organization || '-',
      'Registry Domain ID': response!.domain.registryDomainId || '-',
      'Name Servers': response!.domain.nameservers.join(',') || '-',
      'Registrar Name': response!.domain.registrarName || '-',
      'Abuse Contact Mail': response!.domain.abuseContactEmail || '-',
      'Abuse Contact Phone': response!.domain.abuseContactPhone || '-',
      Created: response!.domain.created || '-',
      Updated: response!.domain.updated || '-',
      'Registry Expiration': response!.domain.registryExpiration || '-',
    };
  };

  private getIcon = (key: string) => {
    switch (key) {
      case 'Name':
        return <Icon icon={'name'} size={18} />;
      case 'Organization':
        return <Icon icon={'organization'} size={18} />;
      case 'Registry Domain ID':
        return <Icon icon={'registry-domain-id'} size={18} />;
      case 'Name Servers':
        return <Icon icon={'name-servers'} size={18} />;
      case 'Registrar Name':
        return <Icon icon={'name'} size={18} />;
      case 'Abuse Contact Mail':
        return <Icon icon={'abuse-contact-mail'} size={18} />;
      case 'Abuse Contact Phone':
        return <Icon icon={'abuse-contact-phone'} size={18} />;
      case 'Created':
        return <Icon icon={'added-date'} size={18} />;
      case 'Updated':
        return <Icon icon={'breache-date'} size={18} />;
      case 'Registry Expiration':
        return <Icon icon={'first-seen'} size={18} />;
      default:
        return <Icon icon={'domain'} size={18} />;
    }
  };
}

interface Props {
  response: WatchlistCustomerDomains | undefined;
  customerLoading: boolean;
}

class State {}

export default WatchlistCustomerDomainsComponent;
